import React, {
  useRef, useEffect, useState
} from 'react';
import { LABEL, CUSTOM_MESSAGES } from '../../veriables';
import Loader from '@components/common/Loader/index';
import cn from 'classnames';
import CustomKeyboard from '@components/common/CustomKeyboard/index';
import Styles from './kioskPayment.module.scss';
import { isEmpty } from 'lodash';
import Tiles from '@components/Tiles';
import Pay from '@containers/Pay';
import PhoneNumberComponent from '@components/common/PhoneNumberComponent/index';
import ReceiptScreen from '../ReceiptScreen/index';
import { getObjectValue, replaceAll } from '@utility/utills';
import Survey from '@containers/Survey';
import QrPayFromPhone from '@components/PaymentScreens/QrPayFromPhone';
import { flowType } from '../../utility/userInfo';
import { getFormatedPhoneNumber } from '@utility/helperFunction';

const Fullcheck = (props) => {
  useEffect(() => {
    if (props.paymentType === 5) {
      props.setOpen(true);
    }
  }, [props.paymentType]);
  const InitialScreen = () => {
    return (
      <div className="col-12 h-100 px-0">
        <div className="col-12 row p-0 justify-content-center h-100 mx-0 py-2 od-app-background-color">
          <div className="row h-20 fw-700 text-primary od-text-primary fs-30 align-items-center justify-content-center">
            {CUSTOM_MESSAGES().HOW_WOULD_YOU_LIKE_TO_PAY}
          </div>
          <div className="row h-80 w-100 align-content-end justify-content-center">
            {getObjectValue(() => props.deviceInfo.deviceGroup.paymentTypes.creditCard, false) && (
              <div className="col-12 text-center">
                <button
                  type="button"
                  disabled={getObjectValue(() => !props.deviceInfo.deviceGroup.paymentTypes.creditCard, false)}
                  className="btn btn-primary btn-ripple btn100 od-btn-primary shadow-none border-0 fw-700 w-70 my-2"
                  onClick={() => props.handlePaymentTypes('creditCard')}
                >
                  <div className="fs-30">{LABEL().KIOSK_CREDIT_CARD}</div>
                </button>
              </div>
            )}
            {getObjectValue(() => props.deviceInfo.deviceGroup.paymentTypes.cash, false) && (
              <div className="col-12 text-center">
                <button
                  type="button"
                  disabled
                  className="btn btn-primary btn-ripple btn100 od-btn-primary shadow-none border-0 fw-700 w-70 my-2"
                  onClick={() => props.handlePaymentTypes('cash')}
                >
                  <div className="fs-30">{LABEL().KIOSK_CASH}</div>
                </button>
              </div>
            )}
            {getObjectValue(() => props.deviceInfo.deviceGroup.paymentTypes.scanToPay, false) && (
              <div className="col-12 text-center">
                <button
                  type="button"
                  disabled={getObjectValue(() => props.deviceInfo.deviceGroup.paymentTypes.creditCard, false)}
                  className="btn btn-primary btn-ripple btn100 od-btn-primary shadow-none border-0 fw-700 w-70 my-2"
                  onClick={() => props.handlePaymentTypes('scan')}
                >
                  <div className="fs-30">{LABEL().SCAN_TO_PAY}</div>
                </button>
              </div>
            )}
            {getObjectValue(() => props.deviceInfo.deviceGroup.brandTipId, false) ? (
              <div className="col-12 text-center">
                <button
                  type="button"
                  className="btn btn-primary btn-ripple btn100 od-btn-primary shadow-none border-0 fw-700 w-70 my-2"
                  onClick={() => props.handlePaymentTypes('goBack')}
                >
                  <div className="fs-30">{LABEL().BACK_TO_TIP}</div>
                </button>
              </div>
            ) : (
              <div className="col-12 text-center">
                <button
                  type="button"
                  className="btn btn-primary btn-ripple btn100 od-btn-primary shadow-none border-0 fw-700 w-70 my-2"
                  onClick={() => props.goToCart()}
                >
                  <div className="fs-30">{LABEL().BACK_TO_CART}</div>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  const PayAtCounterScreen = () => {
      return (
    <>
      { props.loading && <Loader /> }
      <div className="col-12 h-100 px-0">
        <div className="col-12 row p-0 justify-content-center h-100 mx-0 py-2 od-app-background-color">
          <div className="row h-20 fw-700 text-primary od-text-primary fs-30 align-items-center justify-content-center text-center">
            {CUSTOM_MESSAGES().PLEASE_COMPLETE_PAYMENT_AT_THE_COUNTER}
          </div>
          <div className="row h-20 fw-700 text-primary od-text-primary fs-30 align-items-center justify-content-center text-center">
            {CUSTOM_MESSAGES().PRESS_CONTINUE_TO_PLACE_ORDER}
          </div>
          <div className="row col-12 h-20 fw-700 text-primary od-text-primary fs-30 align-items-center justify-content-center text-center" style={{paddingTop: '8rem'}}>
            <div className='col-6'>
            <button
                  type="button"
                  className="btn btn-primary btn-ripple btn100 od-btn-primary shadow-none border-0 fw-700 w-100 my-2"
                  onClick={() => props.goToCart()}
                >
                  <div className="fs-28">{LABEL().BACK_TO_CART}</div>
                </button>
            </div>
            <div className='col-6'>
            <button
                  type="button"
                  className="btn btn-primary btn-ripple btn100 od-btn-primary shadow-none border-0 fw-700 w-100 my-2"
                  onClick={() => {props.continueFireApi()}}
                >
                  <div className="fs-28">{LABEL().CONTINUE}</div>
                </button>
            </div>
          </div>
        </div>
      </div>
   </> );
  };

  const CashconfirmationScreen = () => {
    return (
      <div className="col-12 px-2">
        <div className="col-12 row justify-content-center h-100 mx-0 py-2 od-app-background-color">
          <div className="col-12 row h-5 text-primary od-text-primary fs-18 align-items-end justify-content-center">
            {CUSTOM_MESSAGES().CASH_PAYMENTS_ARE_MADE_AT_THE_COUNTER}
          </div>
          <div className="col-12 row h-5 text-primary od-text-primary fs-18 align-items-end justify-content-center">
            {CUSTOM_MESSAGES().DO_YOU_WANT_TO_CONTINUE_PAYING_WITH_CASH}
          </div>
          <div className="row h-20 w-100 align-items-start justify-content-center">
            <button
              type="button"
              className={cn('btn btn-primary btn-ripple od-btn-primary shadow-none rounded border-0 fw-700 w-100 fs-18 my-2')}
              onClick={() => props.handleCashPayment()}
            >
              {LABEL().PAY_AT_COUNTER_WITH_CASH}
            </button>
            <button
              type="button"
              className={cn('btn btn-primary btn-ripple od-btn-primary shadow-none rounded border-0 fw-700 w-100 fs-18 my-2')}
              onClick={() => { props.handleCreditCard(); }}
            >
              {LABEL().PAY_WITH_CREDIT_DEBIT}
            </button>
          </div>
          <div className="h-70" />
        </div>
      </div>
    );
  };

  const PaymentReceipt = () => {
    return (
      <div className="col-12 h-100 px-0">
        <div className="col-12 row p-0 justify-content-center h-100 mx-0 py-2 od-app-background-color">
          <div className="row h-20 fw-700 text-primary od-text-primary fs-30 align-items-end justify-content-center">
            {CUSTOM_MESSAGES().WOULD_YOU_LIKE_A_RECEIPT}
          </div>
          <div className="row h-80 w-100 align-content-end justify-content-center">
            <div className="col-12 text-center">
              <button
                type="button"
                className="btn btn-primary btn-ripple btn100 od-btn-primary shadow-none border-0 fw-700 w-70 my-2"
                onClick={() => props.handleReceipt('text')}
              >
                <div className="fs-30">{LABEL().TEXT_IT_TO_ME}</div>
              </button>
            </div>
            <div className="col-12 text-center">
              <button
                type="button"
                className="btn btn-primary btn-ripple btn100 od-btn-primary shadow-none border-0 fw-700 w-70 my-2"
                onClick={() => props.handleReceipt('email')}
              >
                <div className="fs-30">{LABEL().EMAIL_IT_TO_ME}</div>
              </button>
            </div>
            <div className="col-12 text-center">
              <button
                type="button"
                className="btn btn-primary btn-ripple btn100 od-btn-primary shadow-none border-0 fw-700 w-70 my-2"
                onClick={() => props.handleReceipt('receipt')}
              >
                <div className="fs-30">{LABEL().NO_THANK_YOU}</div>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const [openKeyboard, setOpenKeyboard] = useState(true);
  const [typed, setTyped] = useState({
    email: '',
    text: Number(props.countryCode) === 1 ? getObjectValue(() => getFormatedPhoneNumber(props.check.orders[0].phoneNumber), '') : getObjectValue(() => props.check.orders[0].phoneNumber, ''),
    notification: false
  });
  const [inputs, setInputs] = useState(JSON.parse(window.sessionStorage.getItem('inputs')) || {
    email: '',
    text: Number(props.countryCode) === 1 ? getObjectValue(() => getFormatedPhoneNumber(props.check.orders[0].phoneNumber), '') : getObjectValue(() => props.check.orders[0].phoneNumber, ''),
    notification: false
  });

  const ReceiptPage = () => {
    const keyboard = useRef(null);
    const ref = useRef(null);
    const [keyboardType, setKeyboardType] = useState(props.receiptType.key === 'text' ? 'number' : 'shift');
    const handleBlur = () => {
      setOpenKeyboard(true);
      document.querySelector(`#${props.receiptType.key}`).blur();
    };

    const setEmpty = (data) => {
      setInputs({
        ...inputs,
        [data]: '',
        notification: false
      });
      setTyped({
        ...inputs,
        [data]: '',
        notification: false
      });
    };

    const returnMaxLength = () => {
      if (Number(props.countryCode) === 1 && props.receiptType.key === 'text' && inputs?.text?.includes('-')) {
        return 12;
      }
      return props.receiptType.maxlength;
    };

    const onClickBtn = (e) => {
      if (ref.current) {
        const totalDist = +(ref.current?.scrollWidth - ref.current?.clientWidth) || 0;
        ref.current.scrollLeft = totalDist;
      }
      setTyped(e === '{bksp}' ? { ...typed, [props.receiptType.key]: typed[props.receiptType.key]?.slice(0, -1) } : { ...typed, [props.receiptType.key]: typed[props.receiptType.key] ? typed[props.receiptType.key].concat(e) : ''.concat(e) });
      const value = e === '{bksp}' ? { ...typed, [props.receiptType.key]: typed[props.receiptType.key]?.slice(0, -1) } : { ...typed, [props.receiptType.key]: typed[props.receiptType.key] ? typed[props.receiptType.key].concat(e) : ''.concat(e) };
      setInputs({
        ...inputs,
        error: '',
        [props.receiptType.key]: Number(props.countryCode) === 1 && props.receiptType.key === 'text' ? getFormatedPhoneNumber(value[props.receiptType.key]) : value[props.receiptType.key]
      });
    };
    useEffect(() => {
      if (keyboard.current) {
        keyboard.current.input = {
          ...inputs
        };
      }
    }, [openKeyboard]);


    const getInput = (key) => {
      return inputs[key];
    };

    const validate = () => {
      return new Promise((resolve, reject) => {
        let errorMessage = '';
        const phoneLength = inputs[props.receiptType.key] && replaceAll(inputs[props.receiptType.key], '-');
        if (!inputs[props.receiptType.key]) {
          errorMessage = 'This field is required';
        } else if (Number(props.countryCode) === 1 && props.receiptType.key === 'text' && phoneLength.length < 10) {
          errorMessage = 'Phone number must be 10 digits';
        } else if (props.receiptType.key === 'email' && !inputs[props.receiptType.key].match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
          errorMessage = 'Enter valid a email address';
        }
        if (isEmpty(errorMessage)) {
          resolve();
        } else {
          reject(errorMessage);
        }
      });
    };

    const handleReceiptBack = () => {
      setInputs({
        email: '',
        text: Number(props.countryCode) === 1 ? getObjectValue(() => getFormatedPhoneNumber(props.check.orders[0].phoneNumber), '') : getObjectValue(() => props.check.orders[0].phoneNumber, ''),
        notification: false
      });
      props.handleReceiptBack();
    };

    const handleSubmit = () => {
      validate().then(() => {
        props.submitReceipt(inputs[props.receiptType.key], inputs.notification);
      }).catch((err) => {
        setInputs({ ...inputs, error: err });
      });
    };

    const closeKeyboard = () => {
      setOpenKeyboard(false);
    };

    return (
      <div className="h-100 w-100 p-0 row m-0 align-items-start od-app-background-color position-relative">
        <div className="col-12 h-100 px-0 m-0 mt-4 large-input">
          <div className="h-10 fs-26 text-center text-primary od-text-primary row align-items-center justify-content-center">{props.receiptType.head}</div>
          <div className={cn('position-relative h-15')}>
            {props.receiptType.key === 'text' && (<PhoneNumberComponent
              styles={{
                top: '50%',
                left: 0,
                transform: 'translateY(-50%)',
                padding: 'p-2',
                zIndex: 999
              }}
              countryCode={props.countryCode}
              handleCountryCodeChange={props.handleCountryCodeChange}
            />)}
            <input
              value={getInput(props.receiptType.key)}
              type="text"
              ref={ref}
              className={cn('col-12 form-control h-100')}
              style={{ height: '8vh', fontSize: '3vh' }}
              id={props.receiptType.key}
              name={props.receiptType.key}
              onFocus={() => { getInput(props.receiptType.key); handleBlur(); }}
            />
          </div>
          {inputs && inputs.error && <div className="text-center fs-14 error">{inputs.error}</div>}
          {inputs && inputs[props.receiptType.key] && inputs[props.receiptType.key].length > 0 && (
            <div
              role="presentation"
              className="position-absolute"
              style={{
                right: '2%', top: '18%', transform: 'translateY(-50%)', zIndex: '999'
              }}
              onClick={() => { setEmpty(props.receiptType.key); }}
            >
              <i className="fa fs-14 fa-times text-secondary od-text-secondary" aria-hidden="true" />
            </div>
          )}
          <div className="col-12 d-flex w-100 p-0 h-70 justify-content-center align-items-end">
            <div className="col-6 pl-0">
              <button
                className={cn('w-100 mt-2 btn btn100 btn-primary btn-ripple od-btn-primary rounded')}
                type="submit"
                onClick={() => handleReceiptBack()}
              >
                <div className="fs-30">{LABEL().GO_BACK}</div>
              </button>
            </div>
            <div className="col-6 pr-0">
              <button
                className={cn('w-100 mt-2 btn btn100 btn-primary btn-ripple od-btn-primary pl-1 rounded')}
                type="submit"
              // style={{ fontSize: '50px' }}
                onClick={() => handleSubmit()}
              >
                <div className="fs-30">{props.receiptType.key === 'text' ? LABEL().SEND_TEXT : LABEL().SEND_EMAIL}</div>
              </button>
            </div>
          </div>
        </div>
        {openKeyboard ? (
            <CustomKeyboard
              setKeyboardType={setKeyboardType}
              onClickBtn={(e) => onClickBtn(e)}
              type={props.receiptType.key === 'text' ? keyboardType : 'kiosk'}
              typed={inputs[props.receiptType.key] || ''}
              closeKeyboard={closeKeyboard}
              btnSize="btn35"
              customClass={cn('fs-30 background-primary od-app-background-color od-border-secondary', props.receiptType.key === 'text' ? `col-lg-6 col-md-6 justify-content-center position-absolute ${Styles.arrow}` : `col-12 p-0 text-right position-absolute ${Styles.arrowAlpha}`)}
              maxLength={returnMaxLength()}
            />
        ) : (
         <></>
        )}
      </div>
    );
  };

  const renderModifier = (modifiersObj, node) => (
    <div className={cn('pl-2')}>
      {modifiersObj && modifiersObj.map((modifier) => {
        if (modifier.modifiers && modifier.modifiers.length === 1 && getObjectValue(() => !modifier.modifiers[0].modifierGroupId, false)) {
          return (
            <div key={modifier.id} className="fs-14 fw-500">
              {modifier.modifiers[0].quantity > 1 && (<span className={cn('badge badge-warning ml-1 va-tt', node === 0 ? 'float-right' : '')}>{modifier.modifiers[0].quantity} &times;</span>)}
              {modifier.modifierName}
              {modifier.quantity > 1 && (<span className="badge badge-warning ml-1 va-tt">&times; {modifier.quantity}</span>)}
              {modifier.price ? (<small className="ml-1">{LABEL().CURRENCY_SYMBOL}{modifier.price.toFixed(2)}</small>) : ''}
            </div>
          );
        }
        return (
          <div key={modifier.id} className="fs-14 fw-500">
            {modifier.quantity > 1 && <span className={cn('badge badge-warning ml-1 va-tt', node === 0 ? 'float-right' : '')}>{modifier.quantity} &times;</span>}
            {modifier.modifierName}
            {modifier.price ? (<small className="ml-1">{LABEL().CURRENCY_SYMBOL}{modifier.price.toFixed(2)}</small>) : ''}
            {(modifier.note || modifier.comment) && <div className="pl-2">{modifier.note || modifier.comment}</div>}
            {modifier.modifiers && modifier.modifiers.length > 0 && (
              renderModifier(modifier.modifiers)
            )}
          </div>
        );
      })}
    </div>
  );

  const IngenicoPayImg = () => (
    <div className="row h-100 py-2 w-100 align-items-center m-0 justify-content-center">
      <div className="text-center text-primary od-text-primary m-0 fs-38 fw-700">
        {CUSTOM_MESSAGES().PLEASE_CONTINUE_THE_PAYMENT}
      </div>
      {!props.isHideContinueBtn && (
        <div className="text-center text-primary od-text-primary m-0 fs-38 fw-700">
          {CUSTOM_MESSAGES().PRESS_CONTINUE}
        </div>
      )}
      {!props.isHideContinueBtn && (
        <div className="row h-30 w-100 justify-content-center align-items-end p-0">
          <div className="col-6">
            <button
              type="button"
              className="btn btn100 btn-primary btn-ripple od-btn-primary w-50 rounded shadow-none border-0 fw-700 w-100 fs-20"
              onClick={() => props.goToCart()}
            >
              <div className="fs-24">{LABEL().BACK_TO_CART}</div>
            </button>
          </div>
          <div className="col-6">
            <button
              type="button"
              className="btn btn100 btn-primary btn-ripple od-btn-primary w-50 rounded shadow-none border-0 fw-700 w-100 fs-20"
              onClick={() => { props.handleCreditCard(); }}
            >
              <div className="fs-24">{LABEL().KIOSK_CONTINUE}</div>
            </button>
          </div>
        </div>
      )}
    </div>
  );

  const QRPayImg = () => (
    <div className="row h-100 py-2 w-100 align-items-center m-0 justify-content-center">
      <div className="text-center text-primary od-text-primary m-0 fs-34 fw-700">
        {CUSTOM_MESSAGES().SCAN_QR_CONFIRM_MESSAGE}
      </div>
      {!props.isHideContinueBtn && (
        <div className="text-center text-primary od-text-primary m-0 fs-34 fw-700">
          {CUSTOM_MESSAGES().PRESS_CONTINUE}
        </div>
      )}
      {!props.isHideContinueBtn && (
        <div className="row h-30 w-100 justify-content-center align-items-end p-0">
          <div className="col-6">
            <button
              type="button"
              className="btn btn100 btn-primary btn-ripple od-btn-primary w-50 rounded shadow-none border-0 fw-700 w-100 fs-20"
              onClick={() => props.goToCart()}
            >
              <div className="fs-24">{LABEL().BACK_TO_CART}</div>
            </button>
          </div>
          <div className="col-6">
            <button
              type="button"
              className="btn btn100 btn-primary btn-ripple od-btn-primary w-50 rounded shadow-none border-0 fw-700 w-100 fs-20"
              onClick={() => { props.scanPaymentInit(); }}
            >
              <div className="fs-24">{LABEL().KIOSK_CONTINUE}</div>
            </button>
          </div>
        </div>
      )}
    </div>
  );

  const ReceiptScreenWithPayment = () => {
    return (
      <div className="h-100" id="paymentPage">
        {!props.isHeight && (
          <div className="col-12 w-100 h-50 row mx-0 p-0">
            {props.tileImage?.length > 0 && props.tileImage[0]?.imageUrl?.length > 0 && (
              <div className="h-30 col-12 p-0">
                <Tiles
                  data={getObjectValue(() => props.tileImage?.filter((e, i) => i === 0 && e), [])}
                />
              </div>
            )}
            <div className={cn('col-12 px-4', props.tileImage?.length > 0 && props.tileImage[0]?.imageUrl?.length > 0 ? 'h-70' : 'h-100')}>
              {props.showPayment.showReceiptCard && (<ReceiptScreen isKiosk={flowType() === 'kiosk'} currenySymbol={props.currencySymbol} paymentType={props.showPayment.ingenico || props.showPayment.showPay || props.showPayment.qrCode || props.showPayment.showError || props.showPayment.showInitial || props.showPayment.qrConfirm ? 1 : 20} supportsTips tableData={props.tableData} tipAmount={props.tipAmount} keyboardValue={props.keyboardValue} handleKeyboardValue={props.handleKeyboardValue} handleButtonClick={props.handleButtonClick} active={props.active} renderModifier={renderModifier} />)}
            </div>
          </div>
        )}
        <div className={cn(!props.isHeight ? 'h-50' : 'h-100', 'col-12 d-flex align-items-center px-4')}>
          {props.showPayment.showPay && (
          <Pay goToReceipt={props.goToReceipt} paymentCallBack={props.paymentCallBack} handleFailureRoute={props.handleFailureRoute} />
          )}
          {props.showPayment.showReceipt && (
          <PaymentReceipt />
          )}
          {props.showPayment.showReceiptType && (
          <ReceiptPage />
          )}
          {props.showPayment.showError && (
          <PaymentFailure />
          )}
          {props.showPayment.showSurvey && (
          <Survey handleSurveySubmit={props.handleSurveySubmit} />
          )}
          {props.showPayment.showInitial && (
            <InitialScreen />
          )}
          {props.showPayment.showpayatcounter && (
            <PayAtCounterScreen />
          )}
          {props.showPayment.qrConfirm && (
            <QRPayImg />
          )}
          {props.showPayment.qrCode && (
            <div className="h-100 w-100">
              <div className="text-center text-primary od-text-primary m-0 fs-26 fw-700">{CUSTOM_MESSAGES().SCAN_MESSAGE}</div>
              <div className="col-12 text-center text-primary od-text-primary fs-24">{props.counter}</div>
              <div className="h-60"><QrPayFromPhone handleCheck={props.handleCheck} /></div>
            </div>
          )}
          {props.showPayment.ingenico && (
            <IngenicoPayImg />
          )}
        </div>

      </div>
    );
  };

  const Tips = () => {
    return (
      <div className="h-100 px-4">
        <div className="col-12 w-100 h-100 row mx-0 p-0">

          {props.showPayment.showTips && (
            <div className="col-12 p-0 w-100 h-100">
              {props.tipsList && props.tipsList.length > 0
                ? (
                    <>
                      <div className="h-50">
                      <div className="fs-30 h-50 d-flex align-items-center od-text-primary text-primary justify-content-center my-2">{LABEL().SELECT_TIP}</div>
                      <div className="col-12 h-50 d-flex align-items-center justify-content-center od-text-primary text-primary fs-20 p-0">
                        <div className={cn('col-12 text-center p-0 m-0', Styles.wrapper)}>
                          {props.tipsList.map((item) => {
                            return (
                              <div
                                key={item.key}
                                role="presentation"
                                onClick={() => {
                                  props.handleKeyboardValue('');
                                  props.handleButtonClick(item.key);
                                } }
                                className={cn('border rounded border-color-secondary flex-grow d-flex flex-column align-items-center justify-content-center od-border-secondary', item.key === props.active ? 'bg-grey color-white od-btn-secondary' : '')}
                              >
                                <div>{item.displayKey}</div>
                                {(item.ruleType === 1) && ![4, 5].includes(item.id) && <div>({LABEL().CURRENCY_SYMBOL}{((Number(props.totalAmountForTip) * Number(item.key)) / 100).toFixed(2)})</div>}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                      <div className="col-12 h-50 p-0 text-center py-2">
                        <div className="h-60 d-flex align-items-end">
                          <div
                            className="col-12 p-0 p-1 border od-text-primary text-primary rounded od-container-card-background od-container-card-border background-primary border-color-secondary fs-18"
                            style={{
                              bottom: '0px',
                              left: '0px',
                            }}
                          >
                            <div className="row m-0 fw-700">
                              <div className="col-4 text-left">{LABEL().TOTAL} </div>
                              <div className="col-8 text-right">
                                {props.currencySymbol}{props.tableData && (props.tableData.totalAmount - props.tableData.paidAmount).toFixed(2)}
                              </div>
                            </div>
                            <div className="row m-0 fw-700">
                              <div className="col-4 text-left">{LABEL().TIP} </div>
                              <div className="col-8 text-right">
                                {props.currencySymbol}{(props.tipAmount && Number(props.tipAmount).toFixed(2)) || (props.tableData && Number(props.tableData.tipAmount).toFixed(2))}
                              </div>
                            </div>
                            <div className="row m-0 fw-700">
                              <div className="col-4 text-left">{LABEL().RECEIPT_PAYMENT} </div>
                              <div className="col-8 text-right">
                                {props.currencySymbol}{(props.tableData && (props.tableData.totalAmount - props.tableData.paidAmount + Number(props.tipAmount)).toFixed(2))}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="h-40 col-12 p-0 d-flex align-items-end">
                          <div className="col-6 pl-0">
                            <button
                              type="button"
                              className="btn btn100 rounded od-btn-primary btn-primary btn-ripple rouned w-100 my-1"
                              onClick={() => props.orderMoreItems()}
                            >
                              <div className="fs-18">{LABEL().ORDER_MORE_ITEMS}</div>

                            </button>
                          </div>
                          <div className="col-6 pr-0">
                            <button
                              type="button"
                              className="btn btn100 rounded od-btn-primary btn-primary btn-ripple rouned w-100 my-1"
                              onClick={() => (props.payType === 'scan' ? props.handleTypes('scan') : props.handleCheck('tips'))}
                              disabled={!(props.payType === 'card' || props.payType === 'all' || props.payType === 'scan')}
                            >
                              <div className="fs-18">{props.btnName}</div>

                            </button>
                          </div>
                        </div>
                      </div></>
                ) : null}
            </div>
          )}
        </div>
      </div>
    );
  };

  const OrderComplete = () => {
    const themeProperties = JSON.parse(window.sessionStorage.getItem('themeProperties')) || {};
    return (
      <div className="col-12 h-100 mx-0 px-0 text-primary od-app-background-color">
        <div className="col-12 h-70 p-0 row m-0 align-items-start text-center fw-700">
          <div className="col-12 p-0">
            <img
              src={themeProperties.kioskConfirmationPageImageUrl}
              alt="fullimage"
              sytle={{ objectFit: 'cover' }}
              className={`img-fluid w-100 d-block mx-auto ${Styles.maxHeight}`}
            />
          </div>
          <div className="col-12">
            <div className="mb-2 fs-30 od-text-primary text-primary">
              {CUSTOM_MESSAGES().YOUR_ORDER_PLACED}
            </div>
            <div className="mb-2 fs-30 od-text-primary text-primary">
              {CUSTOM_MESSAGES().THANK_YOU}
            </div>
          </div>
        </div>
        <div className="col-12 h-10 text-center text-primary od-text-primary fs-24">{props.count}</div>
        <div className="h-20 fs-30 col-12 d-flex align-items-end justify-content-center px-4">
          <button
            type="button"
            className="btn btn100 rounded od-btn-primary btn-primary btn-ripple rouned w-70 my-1"
            onClick={() => props.goToLandingPage()}
          >
            <div className="fs-30">{LABEL().START_NEW_ORDER}</div>

          </button>
        </div>
      </div>
    );
  };

  const PaymentFailure = () => {
    return (
      <div className="col-12 h-100 mx-0 py-4 text-primary od-app-background-color">
        <div className={cn(props.errorMessage.split('.').length > 1 ? 'h-30' : 'h-50', 'col-12 text-primary m-0 fs-38 od-text-primary text-center fw-700 p-0')}>
          {props.errorMessage.split('.').length > 0 && props.errorMessage.split('.')[0]}
        </div>
        {props.errorMessage.split('.').length > 1 && (
          <div className="col-12 h-20 text-primary m-0 fs-14 od-text-primary text-center fw-700 p-0">
            {`[${props.errorMessage.split('.')[1]}]`}
          </div>)}
        {props.showRetryMessage && (
          <div className="py-2 h-30 text-center text-primary od-text-primary m-0 fs-38 fw-700">
            {CUSTOM_MESSAGES().RETRY_WHEN_READY}
          </div>
        )}
        <div className="row h-20 justify-content-center align-items-end p-0">
          <button
            type="button"
            className="btn btn100 btn-primary btn-ripple od-btn-primary rounded shadow-none border-0 fw-700 w-70 fs-20"
            onClick={() => props.handleRetry()}
          >
            <div className="fs-30">{LABEL().RETRY}</div>
          </button>
        </div>
      </div>
    );
  };

  const handlePayment = () => {
    switch (Number(props.paymentType)) {
      case 1: return <InitialScreen />;
      case 2: return <CashconfirmationScreen />;
      case 3: return <PaymentReceipt />;
      case 4: return <ReceiptPage />;
      case 5: return <OrderComplete />;
      case 6: return <Pay goToReceipt={props.goToReceipt} paymentCallBack={props.paymentCallBack} handleFailureRoute={props.handleFailureRoute} />;
      case 7: return <PaymentFailure />;
      case 8: return <Tips />;
      case 9: return <ReceiptScreenWithPayment />;
      case 10: return <Survey handleSurveySubmit={props.handleSurveySubmit} />;

      default: return <></>;
    }
  };

  return (
    <>
      {handlePayment()}
    </>
  );
};

export default Fullcheck;
